import { useTranslation } from 'react-i18next';

import Text from '@/components/ui/custom/dataDisplay/Text';
import HiddenComponents from '@/components/ui/custom/HiddenComponents';
import TeachingWeek from '@/components/staff/TeachingWeek/TeachingWeek';
import YourLessons from '@/components/staff/YourLessons';
import PendingHomeworks from '@/components/teacher/PendingHomeworks';
import useConfigContext from '@/data/hook/config';
import useAuth from '@/data/hook/useAuth';

export default function TeacherDashboardView() {
  const { user } = useAuth();

  const { t: tDashboard } = useTranslation('translation', {
    keyPrefix: 'dashboard',
  });

  const { hiddenComponents, hideComponent, showComponent } = useConfigContext();

  const classNameCard = { base: 'sm:w-[418px] lg:w-[600px]' };

  if (!user) return null;

  return (
    <div className="flex flex-col gap-6 h-full">
      <div className="flex flex-col gap-4">
        <Text
          text={tDashboard('hello') + user?.firstName + ' 👋'}
          className="text-primary"
          format="poppins-600"
          size="text-28"
        />
        <Text
          text={tDashboard('wellcome.teacher')}
          format="rubik-400"
          size="text-16"
          className="break-words"
        />
      </div>
      <div className="flex items-start gap-2.5 md:gap-5 transition-all ease-in-out duration-500 flex-wrap lg:flex-nowrap">
        <YourLessons user={user} className={classNameCard} />
        <PendingHomeworks className={classNameCard} />
      </div>

      <TeachingWeek
        render={hiddenComponents?.teachingWeek}
        updateRender={hideComponent}
        user={user}
        className={{ section: 'h-[30rem]' }}
      />
      <HiddenComponents
        render={!!hiddenComponents}
        sections={hiddenComponents}
        updateRender={showComponent}
      />
    </div>
  );
}
